  $('.customquickview').on('click', function () {
    var prohandle = $(this).attr('prohandle');
    $('.csutom' + prohandle).click();
  });

var apival = (localStorage.getItem('selected_api') || '').trim();
var sigmaval = (localStorage.getItem('selected_sigma') || '').trim();
var symbionval = (localStorage.getItem('selected_symbion') || '').trim();
var ch2val = (localStorage.getItem('selected_ch2') || '').trim();

// Function to add class and check previous input
function addClassAndCheckPreviousInput(parentSelector, className, newClass) {
  if (!className) return;

  var parent = document.querySelector(parentSelector);
  if (!parent) {
    //console.warn('Parent not found:', parentSelector);
    return;
  }

  var el = parent.querySelector('.' + className);
  if (el) {
    // Add class if not already present
    if (!el.classList.contains(newClass)) {
      el.classList.add(newClass);
     // console.log('Class added:', newClass, 'to', className, 'inside', parentSelector);
    } else {
     // console.log('Element already has class:', newClass, '->', className, 'inside', parentSelector);
    }

    // Check the previous input if it exists
    var prevInput = el.previousElementSibling;
    if (prevInput && prevInput.tagName.toLowerCase() === 'input') {
      if (!prevInput.checked) {
        prevInput.checked = true;
       // console.log('Previous input checked for', className);
      } else {
       // console.log('Previous input already checked for', className);
      }
    } else {
     // console.warn('No previous input found for', className);
    }

  } else {
   // console.warn('No element found for class inside', parentSelector + ':', className);
  }
}

// Usage
addClassAndCheckPreviousInput('.mobileseller', apival, 'custom-active');
addClassAndCheckPreviousInput('.mobileseller', sigmaval, 'custom-active');
addClassAndCheckPreviousInput('.mobileseller', symbionval, 'custom-active');
addClassAndCheckPreviousInput('.mobileseller', ch2val, 'custom-active');

// Remove 'custom-active' only from the clicked .customlable
document.querySelectorAll('.customlable').forEach(function(label) {
  label.addEventListener('click', function() {
    if (label.classList.contains('custom-active')) {
      label.classList.remove('custom-active');
    //  console.log('Removed custom-active from clicked element:', label);
    }
  });
});









var apival = (localStorage.getItem('selected_api') || '').trim();
var sigmaval = (localStorage.getItem('selected_sigma') || '').trim();
var symbionval = (localStorage.getItem('selected_symbion') || '').trim();
var ch2val = (localStorage.getItem('selected_ch2') || '').trim();

// Function to trigger click inside .desktopseller
function triggerClickByClass(className) {
  if (className) {
    var parent = document.querySelector('.desktopseller');
    if (!parent) return;

    var el = parent.querySelector('.' + className);
    if (el) {
      el.click();
     // console.log('Clicked:', className);
    } else {
    //  console.warn('No element found in .desktopseller for class:', className);
    }
  }
}

// Trigger clicks
triggerClickByClass(apival);
triggerClickByClass(sigmaval);
triggerClickByClass(symbionval);
triggerClickByClass(ch2val);


var getvalueapi = localStorage.getItem('selected_api');
getvalueapi = getvalueapi.replace('api', '');
getvalueapi = getvalueapi.replace(/api/gi, '');

var getvalue = localStorage.getItem('selected_sigma') || '';
var getvaluesymbion = localStorage.getItem('selected_symbion') || '';
var getvaluech2 = localStorage.getItem('selected_ch2') || '';

// Remove specific keywords
getvalue = getvalue.replace(/sigma/gi, '');
getvaluesymbion = getvaluesymbion.replace(/symbion/gi, '');
getvaluech2 = getvaluech2.replace(/ch2/gi, '');

// Optional: trim whitespace
getvalue = getvalue.trim();
getvaluesymbion = getvaluesymbion.trim();
getvaluech2 = getvaluech2.trim();




document.querySelectorAll('.radio-input').forEach((radio) => {
  radio.addEventListener('click', (event) => {
    var selectedval = event.target.value;

    // go 3 parents up from the clicked radio
    let parent = event.target.closest('.radio-input').parentElement.parentElement.parentElement;

    if (!parent) return; // safety check

    if (selectedval.includes('sigma')) {
      parent.querySelector('.Sigma').value = getvalue;
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('api')) {
      parent.querySelector('.API').value = getvalueapi;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('symbion')) {
      parent.querySelector('.Symbion').value = getvaluesymbion;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('ch2')) {
      parent.querySelector('.Ch2').value = getvaluech2;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
    }else if (selectedval.includes('sigma')) {
      parent.querySelector('.Sigma').value = getvalue;
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('API')) {
      parent.querySelector('.API').value = getvalueapi;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('Symbion')) {
      parent.querySelector('.Symbion').value = getvaluesymbion;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('CH2')) {
      parent.querySelector('.Ch2').value = getvaluech2;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
    }
  });
});

document.querySelectorAll('.radio-input').forEach((radio) => {
  radio.addEventListener('click', (event) => {
    var selectedval = event.target.value;

    // go 3 parents up from the clicked radio
    let parent = event.target.closest('.radio-input').parentElement.parentElement.parentElement.parentElement;

    if (!parent) return; // safety check

    if (selectedval.includes('sigma')) {
      parent.querySelector('.Sigma').value = getvalue;
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('api')) {
      parent.querySelector('.API').value = getvalueapi;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('symbion')) {
      parent.querySelector('.Symbion').value = getvaluesymbion;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('ch2')) {
      parent.querySelector('.Ch2').value = getvaluech2;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
    }else if (selectedval.includes('Sigma')) {
      parent.querySelector('.Sigma').value = getvalue;
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('API')) {
      parent.querySelector('.API').value = getvalueapi;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.Symbion').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('Symbion')) {
      parent.querySelector('.Symbion').value = getvaluesymbion;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Ch2').value = '';
    } else if (selectedval.includes('CH2')) {
      parent.querySelector('.Ch2').value = getvaluech2;
      parent.querySelector('.Sigma').value = '';
      parent.querySelector('.API').value = '';
      parent.querySelector('.Symbion').value = '';
    }
  });
});

document.addEventListener('click', function (event) {
  if (!event.target.classList.contains('radio-input')) return;
  if (!event.target.checked) return;

  var customval = event.target.value.toLowerCase();

  function cleanValue(str) {
    return str.replace(/(sigma|api|symbion|ch2)/gi, '').trim();
  }

  var parent = event.target.closest('#quick-view');
  if (!parent) return;

  // Clear all safely
  var sigma = parent.querySelector('.Sigma');
  var api = parent.querySelector('.API');
  var symbion = parent.querySelector('.Symbion');
  var ch2 = parent.querySelector('.Ch2');

  if (sigma) sigma.value = '';
  if (api) api.value = '';
  if (symbion) symbion.value = '';
  if (ch2) ch2.value = '';

  if (customval.includes('sigma') && sigma) {
    sigma.value = cleanValue(getvalue);
  } 
  else if (customval.includes('api') && api) {
    api.value = cleanValue(getvalueapi);
  } 
  else if (customval.includes('symbion') && symbion) {
    symbion.value = cleanValue(getvaluesymbion);
  } 
  else if (customval.includes('ch2') && ch2) {
    ch2.value = cleanValue(getvaluech2);
  }
});




    $('.custom_dropdown').change(function () {

      $(this)
        .parent()
        .find('.custom_dropdown option')
        .each(function () {
          if ($(this).is(':selected')) {
            var customval = $(this).val();
          // console.log(customval);
            if (customval.includes('sigma')) {
const checkedRadio = document.querySelector('.customsigma:checked');
const sigmavalue = checkedRadio ? checkedRadio.value.replace('sigma', '') : '';

              $(this).parent().parent().parent().parent().find('.Sigma').val(sigmavalue);
              $(this).parent().parent().parent().parent().find('.API').val('');
              $(this).parent().parent().parent().parent().find('.Symbion').val('');
              $(this).parent().parent().parent().parent().find('.Ch2').val('');
            } else if (customval.includes('api')) {
// Get the checked radio button for customapi
const customApiRadio = document.querySelector('.customapi:checked');

// Get its value without 'api'
const customApiValue = customApiRadio ? customApiRadio.value.replace('api', '') : '';

              $(this).parent().parent().parent().parent().find('.Sigma').val('');
              $(this).parent().parent().parent().parent().find('.API').val(customApiValue);
              $(this).parent().parent().parent().parent().find('.Symbion').val('');
              $(this).parent().parent().parent().parent().find('.Ch2').val('');
            } else if (customval.includes('symbion')) {
// Get the checked radio button for customsymbion
const customsymbionRadio = document.querySelector('.customsymbion:checked');

// Get its value without 'symbion'
const customsymbionValue = customsymbionRadio ? customsymbionRadio.value.replace('symbion', '') : '';

              $(this).parent().parent().parent().parent().find('.Sigma').val('');
              $(this).parent().parent().parent().parent().find('.API').val('');
              $(this).parent().parent().parent().parent().find('.Ch2').val('');
              $(this).parent().parent().parent().parent().find('.Symbion').val(customsymbionValue);
            } else if (customval.includes('ch2')) {
// Get the checked radio button for customch2
const customch2Radio = document.querySelector('.customch2:checked');

// Get its value without 'ch2'
const customch2Value = customch2Radio ? customch2Radio.value.replace('ch2', '') : '';

              $(this).parent().parent().parent().parent().find('.Sigma').val('');
              $(this).parent().parent().parent().parent().find('.API').val('');
              $(this).parent().parent().parent().parent().find('.Symbion').val('');
              $(this).parent().parent().parent().parent().find('.Ch2').val(customch2Value);
            }
          } else {
            if ($(this).val().includes('sigma')) {
            } else {
            }
          }
        });
    });



  document.addEventListener('DOMContentLoaded', function () {
    function simulateUserClick(element) {
      ['mousedown', 'mouseup', 'click'].forEach((eventType) => {
        const event = new MouseEvent(eventType, {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        });
        element.dispatchEvent(event);
      });
    }

    function checkMatchingInputs() {
      const checkedRadio = document.querySelector('input[name="wholeseller"]:checked');
      if (!checkedRadio) return;

      const checkedValue = checkedRadio.value;
      //console.log('Selected value: ' + checkedValue);

      // Find elements with the class and click them like a real user
      const elements = document.querySelectorAll('.' + checkedValue);
      elements.forEach((el) => {
        if (!el.checked) {
          simulateUserClick(el);
        }
      });
    }

    // Run on page load
    checkMatchingInputs();

    // Run on change
    const radios = document.querySelectorAll('input[name="wholeseller"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', checkMatchingInputs);
    });
  });



  document.addEventListener('DOMContentLoaded', function () {
    function simulateUserSelect(selectElement, valueToSelect) {
      // For real <select> elements
      if (selectElement.tagName.toLowerCase() === 'select') {
        const option = Array.from(selectElement.options).find((opt) => opt.value === valueToSelect);
        if (!option) return;

        selectElement.value = valueToSelect;

        ['mousedown', 'mouseup', 'click', 'change'].forEach((eventType) => {
          const event = new Event(eventType, { bubbles: true, cancelable: true });
          selectElement.dispatchEvent(event);
        });
      } else {
        // For custom dropdown divs
        // Try clicking the option inside the custom dropdown
        const option = selectElement.querySelector(`[data-value="${valueToSelect}"]`);
        if (option) {
          option.click();
        }
      }
    }

    function checkMatchingDropdown() {
      const selectedRadio = document.querySelector('input[name="wholeseller"]:checked');
      if (!selectedRadio) return;

      const checkedValue = selectedRadio.value;
     // console.log('Selected value for dropdown: ' + checkedValue);

      const dropdowns = document.querySelectorAll('.custom_dropdown');
      dropdowns.forEach((dropdown) => {
        if (dropdown.value !== checkedValue) {
          simulateUserSelect(dropdown, checkedValue);
        }
      });
    }

    // Run on page load with a slight delay
    setTimeout(checkMatchingDropdown, 100); // 100ms delay to ensure dropdown is ready

    // Run on change of wholeseller radio
    const radios = document.querySelectorAll('input[name="wholeseller"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', checkMatchingDropdown);
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const DELAY = 1200; // initial delay after clicking the button
    const OBSERVE_TIMEOUT = 5000; // stop observing after this many ms

    const L = (...args) => console.log('[quickview]', ...args);

    function simulateUserClick(el) {
      ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach((type) => {
        el.dispatchEvent(
          new MouseEvent(type, {
            bubbles: true,
            cancelable: true,
            view: window,
            composed: true,
            buttons: 1,
          })
        );
      });
    }

    function triggerChange(el) {
      try {
        el.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) {}
      try {
        el.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    }

    function findMatchingInput(wrapper, value) {
    if (!wrapper || value == null) return null;

    const normalized = ('' + value).trim().toLowerCase();

    const candidates = Array.from(
      wrapper.querySelectorAll(
        'input, label, [data-value], [data-option-value], [data-wholesale], [role="option"], .option'
      )
    );

    for (const el of candidates) {
      if (!el || el.nodeType !== 1) continue;

      const checks = [
        el.value,
        el.getAttribute?.('value'),
        el.getAttribute?.('data-value'),
        el.getAttribute?.('data-option-value'),
        el.getAttribute?.('data-wholesale'),
        el.getAttribute?.('name'),
        el.id,
        el.getAttribute?.('aria-label'),
        typeof el.textContent === 'string' ? el.textContent : null // ✅ FIX
      ];

      for (const ch of checks) {
        if (!ch) continue;

        if (('' + ch).trim().toLowerCase() === normalized) {
          if (el.tagName === 'LABEL') {
            return el.querySelector('input') || el;
          }
          return el;
        }
      }
    }

    return null;
  }
    // main
    document.querySelectorAll('.customquickview').forEach((button) => {
      button.addEventListener('click', (event) => {
        const btn = event.currentTarget;
        setTimeout(() => {
          // scope to nearest logical container OR fallback to document
          const scope = btn.closest('.quick-view-modal, .quick-view, .product-card') || document;

          // look for a checked wholeseller radio (several fallbacks)
          let checked =
            scope.querySelector('.wholeseller-wraper .radio-input:checked') ||
            document.querySelector('.wholeseller-wraper .radio-input:checked');

          if (!checked) {
            // maybe the control is not a real <input> but a custom element with .active
            checked =
              scope.querySelector(
                '.wholeseller-wraper .radio-input.active, .wholeseller-wraper .radio-input.checked'
              ) ||
              document.querySelector(
                '.wholeseller-wraper .radio-input.active, .wholeseller-wraper .radio-input.checked'
              );
          }

          if (!checked) {
            L('No checked wholeseller radio found. Candidates below:');
            const cands = scope.querySelectorAll('.wholeseller-wraper .radio-input');
            L('candidates count:', cands.length);
            cands.forEach((c, i) => L(i, 'val:', c.value || c.getAttribute('value') || c.textContent));
            return;
          }

          const value = (
            checked.value ||
            (checked.getAttribute && checked.getAttribute('data-value')) ||
            (checked.getAttribute && checked.getAttribute('value')) ||
            checked.textContent ||
            ''
          ).trim();
          L('Found wholeseller selected value ->', value);

          // find options wrapper, observe if not present
          let optionsWrapper =
            scope.querySelector('.quick-view-form__options-wrapper') ||
            document.querySelector('.quick-view-form__options-wrapper');

          if (!optionsWrapper) {
            L('Options wrapper not found yet — observing DOM for it for', OBSERVE_TIMEOUT, 'ms');
            const moTarget = document.body;
            const mo = new MutationObserver((mutations, obs) => {
              optionsWrapper =
                scope.querySelector('.quick-view-form__options-wrapper') ||
                document.querySelector('.quick-view-form__options-wrapper');
              if (optionsWrapper) {
                obs.disconnect();
                handleOptions(optionsWrapper, value);
              }
            });
            mo.observe(moTarget, { childList: true, subtree: true });
            setTimeout(() => mo.disconnect(), OBSERVE_TIMEOUT);
          } else {
            handleOptions(optionsWrapper, value);
          }

          function handleOptions(wrapper, val) {
            L('Processing options wrapper for value:', val);
            const candidate = findMatchingInput(wrapper, val);
            if (candidate) {
              L('Matched option element:', candidate);
              // Prefer clicking the label bound to the input (if exists)
              let label = null;
              if (candidate.tagName === 'INPUT') {
                label =
                  wrapper.querySelector("label[for='" + (candidate.id || '') + "']") || candidate.closest('label');
              } else if (candidate.tagName === 'LABEL') {
                label = candidate;
              }

              if (label) {
                L('Clicking label:', label);
                simulateUserClick(label);
              } else {
                L('Clicking element directly:', candidate);
                simulateUserClick(candidate);
              }

              // ensure change/input events fire and checked property set if applicable
              try {
                if (candidate.tagName === 'INPUT' && !candidate.checked) {
                  candidate.checked = true;
                }
              } catch (e) {}

              triggerChange(candidate);
              L('Action complete.');
              return;
            }

            L('No matching option found. Listing inputs/labels inside wrapper for debugging:');
            Array.from(wrapper.querySelectorAll('input, label, [data-value], .option')).forEach((el, idx) => {
              L(
                idx,
                el.tagName || el.nodeName,
                'value=',
                el.value,
                'data-value=',
                el.getAttribute && el.getAttribute('data-value'),
                'id=',
                el.id,
                'text=',
                (el.textContent || '').trim()
              );
            });

            // fallback: click first input if exists
            const first = wrapper.querySelector('input');
            if (first) {
              L('Fallback: clicking first input found in wrapper.');
              const lab = wrapper.querySelector("label[for='" + (first.id || '') + "']") || first.closest('label');
              if (lab) simulateUserClick(lab);
              else simulateUserClick(first);
              try {
                first.checked = true;
              } catch (e) {}
              triggerChange(first);
            } else {
              L('No fallback input available.');
            }
          }
        }, DELAY); // initial delay
      });
    });
  });

  document.addEventListener('click', function (event) {
    // Check if the clicked element has class .qwbtn or is inside it
    var button = event.target.closest('.qwbtn');
    if (!button) return; // exit if click is not on a .qwbtn

    event.preventDefault(); // prevent default action

    // Find the closest .quick-view__form relative to the clicked button
    var form = button.closest('.quick-view__form');
    if (!form) return;

    // Serialize form data
    var formData = new FormData(form);

    // Convert FormData to URL-encoded string
    var params = new URLSearchParams();
    formData.forEach((value, key) => {
      params.append(key, value);
    });

    // Send POST request
    fetch(form.action || '/your-post-url', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    })
      .then((response) => response.json()) // or response.text() depending on backend
      .then((data) => {
        console.log('Form submitted successfully:', data);
      })
      .catch((error) => {
        console.error('Error submitting form:', error);
      });
  });


document.addEventListener('DOMContentLoaded', function() {
  const select = document.getElementById('wholeseller-select');

  select.addEventListener('change', showValue);
  select.addEventListener('input', showValue);

  function showValue() {
    const selectedId = this.value; // value of the selected option

    // 1️⃣ Find the input associated with this value
    const input = document.getElementById(selectedId);

    if (input) {
      // 2️⃣ Find its label
      const label = document.querySelector(`label[for="${input.id}"]`);

      if (label) {
        // 3️⃣ Trigger click on the label
        label.click();
       // console.log("Triggered click on label for input: " + input.id);
      } else {
      //  console.log("No label found for input id: " + input.id);
      }

      // 4️⃣ Optionally, handle related menu block
      const targetBlock = document.querySelector('.header-mega-menu__block #' + selectedId);
      if (targetBlock) {
        targetBlock.classList.add('active');
    //    console.log("Activated menu block: " + selectedId);
      }
    } else {
    //  console.log("No input found with ID: " + selectedId);
    }
  }
});



document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.wholwseller-input').forEach(input => {
    input.removeAttribute("tabindex");
  });
});


 $('.wholwseller-input').on('click', function (event) {
  let value = $(event.target).val();
  let values = $(this).attr('itemnumber');

  // If no wholesale account number → clear fields and stop
  if (!values || values.trim() === '') {
    $('.API, .Sigma, .Symbion, .Ch2').val('');
    return;
  }

  if (value.includes('api')) {
    $('.API').val(values);
  }

  if (value.includes('symbion')) {
    $('.Symbion').val(values);
  }

  if (value.includes('ch2')) {
    $('.Ch2').val(values);
  }

  if (value.includes('sigma')) {
    $('.Sigma').val(values);
  }
});

  localStorage.clear();

  document.addEventListener("DOMContentLoaded", function() {
    const path = window.location.pathname;
    if (path === "/account/logout" || path === "/account/login") {
      localStorage.clear();
    }
  });

